import { render, staticRenderFns } from "./StoreTable.vue?vue&type=template&id=24260b21&scoped=true&"
import script from "./StoreTable.vue?vue&type=script&lang=ts&"
export * from "./StoreTable.vue?vue&type=script&lang=ts&"
import style0 from "./StoreTable.vue?vue&type=style&index=0&id=24260b21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24260b21",
  null
  
)

export default component.exports